import React from 'react'
import { observer } from 'mobx-react-lite'
import DraftStatusBadge from '../../../Shared/DraftStatusBadge'

export default observer(function ReviewingState({ action, role = 'influencer' }) {
  const version = action.action_draft.latestVersion
  const asset = version?.draft_assets[0]

  return (
    <div className="flex flex-col items-center">
      <div className="my-5 p-3 rounded-lg bg-white dark:bg-rb-dark-mode flex justify-between items-center w-[650px] border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter">
        <h2 className="font-bold text-lg dark:text-white">{action.name}</h2>
        <DraftStatusBadge draftStatus={action.action_draft.draft_status} role={role} />
      </div>

      <div className="w-[650px] p-5 rounded-lg bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter flex flex-col items-center">
        {asset && (
          ['mp4', 'mov'].includes(asset.file_type) ? (
            <video src={asset.url} controls className="max-h-80 rounded-lg mb-4" />
          ) : (
            <img src={asset.url} className="max-h-80 rounded-lg mb-4" />
          )
        )}
        {role === 'pm' ? (
          <p className="text-center dark:text-white">This submission is awaiting review. The full review screen is coming in a later cycle.</p>
        ) : (
          <p className="text-center dark:text-white">
            Please note that Reachbird is currently busy reviewing your submission.<br />
            Once asset is reviewed, you will get notified.
          </p>
        )}
      </div>
    </div>
  )
})
